<template>
  <svg xmlns="http://www.w3.org/2000/svg" 
    :width="width" 
    :height="height" 
    viewBox="0 0 18 18" 
    :aria-labelledby="iconName" 
    role="presentation"
  >
    <g :fill="iconColor" >
      <slot />
    </g>
  </svg>
</template>

<script>
export default {
  props: {
    iconName: {
      type: String,
      default: 'box'
    },
    width: {
      type: [Number, String],
      default: 18
    },
    height: {
      type: [Number, String],
      default: 18
    },
    iconColor: {
      type: String,
      default: 'currentColor'
    }
  }
}
</script>

<style scoped>
svg {
  display: inline-block;
  vertical-align: baseline;
  padding: auto;
  justify-content: center;
  align-items: center;
  align-self: center;
  align-content: center;
  margin-bottom: -2px; /* yes, I'm that particular about formatting */
};
</style>